module.exports = __webpack_public_path__ + "img/introDetail.3f8ecfb9.jpg";